var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("table", { staticStyle: { width: "80%" } }, [
      _c("tr", [
        _c("td", [
          _c("table", [
            _c("tr", [
              _c("td", [
                _c("div", { staticStyle: { float: "left" } }, [
                  _c("h1", [_vm._v(_vm._s(_vm.translateWords.title))])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c(
                "td",
                { staticStyle: { padding: "10px" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.translateWords.inputNum },
                    model: {
                      value: _vm.id,
                      callback: function($$v) {
                        _vm.id = _vm._n($$v)
                      },
                      expression: "id"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                { staticStyle: { padding: "10px" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.translateWords.inputName },
                    model: {
                      value: _vm.spmc,
                      callback: function($$v) {
                        _vm.spmc = $$v
                      },
                      expression: "spmc"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.query } },
                    [_vm._v(_vm._s(_vm.translateWords.query))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.OpenPL } },
                    [_vm._v(_vm._s(_vm.translateWords.batchInput))]
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.tableData },
                  on: { "selection-change": _vm.handleSelectionChange }
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "55" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "Id",
                      label: _vm.translateWords.code,
                      width: "100"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "ProductName",
                      label: _vm.translateWords.ProductName,
                      width: "200"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "ProductCode",
                      label: _vm.translateWords.ProductCode
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "ProductType",
                      label: _vm.translateWords.ProductType
                    }
                  }),
                  _vm._v(" "),
                  false
                    ? _c("el-table-column", {
                        attrs: {
                          width: "1",
                          prop: "ProductTypeCode",
                          label: _vm.translateWords.ProductType
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("td", [
          _vm.showpl
            ? _c(
                "div",
                [
                  _c("PLAddSample", {
                    ref: "PLAddSample",
                    attrs: {
                      PositionIdoptions: _vm.guishufangjian,
                      selval: _vm.multipleSelection
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("tr"),
      _vm._v(" "),
      _c("tr", [
        _c("td", [
          _c(
            "div",
            { staticStyle: { float: "left" } },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": 1,
                  "page-sizes": [10, 20, 30],
                  "page-size": 10,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange
                }
              })
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22183c69", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22183c69","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WP.vue
// module id = null
// module chunks = 